import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Dialog, DialogContent, DialogTrigger } from "@tenant/ui";
import { EarnPointsDialogContent } from "./EarnPointsDialogContent";
import { PerkDialogButtons } from "./PerkDialogButtons";
import { PerkDialogItem } from "./PerkDialogItem";
import styles from "./PerkDialogs.module.scss";
import { REWARDS_POINTS_FAQ_URL } from "@/utils/externalPages";

export const EarnPointsDialog = () => {
  const [, cn] = useModuleBEM(styles, "PerkDialogs");
  const { t } = useI18nContext();

  return (
    <PerkDialogItem
      iconName={IconNameEnum.homepagePerkLeft}
      title={t("home.perks.earnPoints.title")}
    >
      <Dialog>
        <DialogTrigger className={cn("item-dialog-trigger")}>
          {t("home.perks.earnPoints.trigger")}
        </DialogTrigger>
        <DialogContent
          bottomFixedContent={
            <PerkDialogButtons rulesUrl={REWARDS_POINTS_FAQ_URL} />
          }
          className={cn("item-dialog-content")}
          showCloseButton={false}
        >
          <EarnPointsDialogContent />
        </DialogContent>
      </Dialog>
    </PerkDialogItem>
  );
};
